const technology = [
  {
    text: 'Zero Footprint Cloud Integration',
    description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. In aliquam, mauris eget',
    ico: 'technology-ico1.svg'
  },
  {
    text: 'Extensible Endpoint Agent',
    description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. In aliquam, mauris eget',
    ico: 'technology-ico4.svg'
  },
  {
    text: 'Granular RBAC',
    description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. In aliquam, mauris eget',
    ico: 'technology-ico7.svg'
  },
  {
    text: 'Configurable Notifications',
    description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. In aliquam, mauris eget',
    ico: 'technology-ico10.svg'
  },
  {
    text: 'Reports and Workflows',
    description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. In aliquam, mauris eget',
    ico: 'technology-ico2.svg'
  },
  {
    text: 'Scalable Data Pipeline',
    description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. In aliquam, mauris eget',
    ico: 'technology-ico5.svg'
  },
  {
    text: 'Dynamic Enrichment',
    description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. In aliquam, mauris eget',
    ico: 'technology-ico8.svg'
  },
  {
    text: 'Cloud File Storage',
    description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. In aliquam, mauris eget',
    ico: 'technology-ico11.svg'
  },
  {
    text: 'Content Marketplace',
    description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. In aliquam, mauris eget',
    ico: 'technology-ico3.svg'
  },
  {
    text: 'Log Archive',
    description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. In aliquam, mauris eget',
    ico: 'technology-ico6.svg'
  },
  {
    text: 'Flexible Orchestration',
    description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. In aliquam, mauris eget',
    ico: 'technology-ico9.svg'
  },
  {
    text: 'Open APIs',
    description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. In aliquam, mauris eget',
    ico: 'technology-ico12.svg'
  }
];

export default technology;

